module.exports = __webpack_public_path__ + "static/media/arrow-right.d285b6cf.svg";